import { useSettings } from '@capsicum/common';

import { useDeleteAccountQuery } from '../data-access';

export const useDeleteAccount = () => {
	const { settings } = useSettings();
	const { mutateAsync: deleteAccountAsync } = useDeleteAccountQuery();
	const supportLink = settings?.contactUsHereLink ?? 'https://mobile-app-content.socios.com/en_gb/contact-us';

	return {
		deleteAccount: deleteAccountAsync,
		privacyLink: settings?.privacyPolicyLink ?? '',
		supportLink
	};
};
